import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import CurrencyContext from './CurrencyContext';
import 'react-alice-carousel/lib/alice-carousel.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CurrencyContext>
      <App />
    </CurrencyContext>
  </React.StrictMode>
);
